__turbopack_context__.v({
  "divider": "ClutchWidget-module-scss-module__Can8Zq__divider",
  "link": "ClutchWidget-module-scss-module__Can8Zq__link",
});
